import { ColorBlock } from './ColorBlock';

export function ColorSingleValue(props) {
  const { value } = props.data;

  return <ColorBlock color={value} label={props.selectProps.label} />;
}
